<template>
    <div class="mainBox">
        <div class="d_title">
            <el-button icon='el-icon-refresh' size="medium" @click='getData'>刷新</el-button>
        </div>
        <div class="mainCt">
            dashboard
        </div>
    </div>
</template>
<script>
    export default{
        name:'dashboard',
        data(){
            return{
                dashboardVal:{}
            }
        },
        mounted() {
            this.getData();
        },
        methods: {
            getData() {}
        }
    }
</script>
<style scoped>
    .d_title{border-bottom:2px solid #999;margin-bottom:30px;position:relative;padding-bottom:10px;}
    .mainCt{padding:10px 20px;}
</style>